<template>
  <div class="">
    <sub-tab :currentTab="tab" :subTab="subTab"></sub-tab>
    <top v-if="tab === 'top'" :currentTab="tab"></top>
    <inventory-inquiry v-if="tab === 'inventory' && subTab === 'inventory-inquiry'"></inventory-inquiry>
    <inventory-end-of-month v-if="tab === 'inventory' && subTab === 'inventory-end-of-month'"></inventory-end-of-month>
    <delivery-status-inquiry v-if="tab === 'delivery' && subTab === 'delivery-status-inquiry'" :currentTab="tab" :subTab="subTab"></delivery-status-inquiry>
    <edit-direct-delivery v-if="tab === 'delivery' && subTab === 'edit-direct-delivery'" :currentTab="tab" :subTab="subTab"></edit-direct-delivery>
    <direct-delivery v-if="tab === 'delivery' && subTab === 'direct-delivery'" :currentTab="tab" :subTab="subTab"></direct-delivery>
    <amazon-delivery v-if="tab === 'delivery' && subTab === 'amazon-delivery'" :currentTab="tab" :subTab="subTab"></amazon-delivery>
    <shipping-status-inquiry v-if="tab === 'shipping' && subTab === 'shipping-status-inquiry'" :currentTab="tab" :subTab="subTab"></shipping-status-inquiry>
    <amazon-shipping v-if="tab === 'shipping' && subTab === 'amazon-shipping'" :currentTab="tab" :subTab="subTab"></amazon-shipping>
    <sc-shipping v-if="tab === 'shipping' && subTab === 'stock-crew'" :currentTab="tab" :subTab="subTab"></sc-shipping>
    <edit-sc-shipping v-if="tab === 'shipping' && subTab === 'edit-stock-crew'" :currentTab="tab" :subTab="subTab"></edit-sc-shipping>
    <multi-channel-shipping v-if="tab === 'shipping' && subTab === 'multi-channel'" :currentTab="tab" :subTab="subTab"></multi-channel-shipping>
    <edit-multi-channel-shipping v-if="tab === 'shipping' && subTab === 'edit-multi-channel'" :currentTab="tab" :subTab="subTab"></edit-multi-channel-shipping>
    <shipping-cost v-if="tab === 'expense-details' && subTab === 'shipment-record'"></shipping-cost>
    <other-cost v-if="tab === 'expense-details' && subTab === 'storage-fees'"></other-cost>
    <setting-across-price-diff v-if="tab === 'settings' && subTab === 'price-diff'"></setting-across-price-diff>
  </div>
</template>
<script>
import Top from './Top'
import InventoryInquiry from './InventoryInquiry'
import InventoryEndOfMonth from './InventoryEndOfMonth'
import DeliveryStatusInquiry from './DeliveryStatusInquiry'
import AmazonDelivery from './AmazonDelivery'
import DirectDelivery from './DirectDelivery'
import EditDirectDelivery from './EditDirectDelivery'
import ShippingStatusInquiry from './ShippingStatusInquiry'
import AmazonShipping from './AmazonShipping'
import ScShipping from './ScShipping'
import EditScShipping from './EditScShipping'
import MultiChannelShipping from './MultiChannelShipping'
import EditMultiChannelShipping from './EditMultiChannelShipping'
import ShippingCost from './ShippingCost'
import OtherCost from './OtherCost'
import SettingAcrossPriceDiff from './SettingAcrossPriceDiff'
import SubTab from './Subtab'

export default {
  data () {
    return {
    }
  },
  components: {
    SubTab,
    Top,
    InventoryInquiry,
    InventoryEndOfMonth,
    DeliveryStatusInquiry,
    DirectDelivery,
    EditDirectDelivery,
    AmazonDelivery,
    ShippingStatusInquiry,
    AmazonShipping,
    ScShipping,
    EditScShipping,
    MultiChannelShipping,
    EditMultiChannelShipping,
    ShippingCost,
    OtherCost,
    SettingAcrossPriceDiff
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    },
    subTab: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.tab-content {
  padding: 10px;
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/TabContent.vue